(ns frontend.test-nev-v3.event
  (:require
   [ui.state.session.model :as session-model]
   [re-frame.core :as rf]
   [potpuri.core :as p]))

(def tasks-card-default-config
  {:table {:columns    [{:field :task/title}
                        {:field :task/due}
                        {:field :task/assignee}
                        {:field :task/completed?}]
           :sort-model [{:field :task/completed?
                         :direction :asc}]
           :entity-type :entity.type/task}
   :entity-peek {:entity-type :entity.type/task
                 :visible-fields-strategy :fields-that-have-value
                 :visible-fields [{:field :task/title}]}})

(def person-associations-table-default-config
  {:title "Linked Contacts"
   :entity-type :entity.type/person
   :columns [{:field :person/first-name
              :source :associated-entity}
             {:field :person/last-name
              :source :associated-entity}
             {:field :person/universal-email-address
              :source :associated-entity}
             {:field :association-type
              :source :association}
             {:field :association-comment
              :source :association}]
   :sort-model [{:field :person/first-name
                 :sort-direction :asc}]
   :group-by-association-type? false
   :entity-peek {:visible-fields-strategy :fields-that-have-value}})

(def company-associations-table-default-config
  {:title "Linked Companies" :entity-type :entity.type/company
   :columns [{:field :asset/name
              :source :associated-entity}
             {:field :association-type
              :source :association}
             {:field :association-comment
              :source :association}]
   :sort-model [{:field :asset/name
                 :sort-direction :asc}]
   :group-by-association-type? false
   :entity-peek {:visible-fields-strategy :fields-that-have-value}})

(def deal-associations-table-default-config
  {:title "Linked Deals"
   :entity-type :entity.type/oppo
   :columns [{:field :oppo/name
              :source :associated-entity}
             {:field :association-type
              :source :association}
             {:field :association-comment
              :source :association}]
   :sort-model [{:field :oppo/name
                 :sort-direction :asc}]
   :group-by-association-type? false
   :entity-peek {:visible-fields-strategy :fields-that-have-value}})

(def fund-view-1
  {:db/id "default-fund-view"
   :entity/type :entity.type/view
   :common/owner "system"
   :view/name "System default view"
   :view/description "System default view for a fund"
   :view/type :view.type/single-entity
   :view/entity-type :entity.type/fund
   :view/cards #{"fund-property-list-card-1"
                 "fund-active-commitments-card"
                 "fund-exited-commitments-card"}
   :view/access-level :view.access-level/private
   :view/configuration {:card-order ["fund-property-list-card-1"
                                     "fund-active-commitments-card"
                                     "fund-exited-commitments-card"]}
   ;; TODO: add something like this to the real view schema?
   :view/system-default? true})

(def fund-property-list-card-1
  {:db/id "fund-property-list-card-1"
   :entity/type :entity.type/card
   :common/owner "system"
   :card/entity-type :entity.type/fund
   :card/type :card.type/property-list
   :card/title "About this fund"
   :card/config {:rows [{:height :auto
                         :cells [{:field :fund/description
                                  :width 4}]}
                        {:height :auto
                         :cells [{:field :fund/status
                                  :width 1}]}]}})

(def fund-active-commitments-card
  {:db/id "fund-active-commitments-card"
   :entity/type :entity.type/card
   :common/owner "system"
   :card/entity-type :entity.type/fund
   :card/type :card.type/entity-list
   :card/title "Active commitments"
   :card/description "This card contains commitments for the fund"
   :card/config {:tables [{:title nil
                           :collapsible? false
                           :entity-type :entity.type/fund-commitment
                           :filters {:operator   :AND
                                     :conditions [{:field    :fund-commitment/fund
                                                   :operator :=
                                                   :value    :primary-entity-id
                                                   :dynamic? true}
                                                  {:field    :fund-commitment/exit-date
                                                   :operator :blank}]}
                           :columns [{:field :fund-commitment/investor}
                                     {:field :fund-commitment/cur-committed-amount}
                                     {:field :fund-commitment/committed-date}
                                     {:field :fund-commitment/stake}
                                     {:field :fund-commitment/net-multiple}
                                     {:field :fund-commitment/net-IRR}
                                     {:field [:fund-commitment/investor :investor/kyc-status]}]}]}})

(def fund-exited-commitments-card
  {:db/id "fund-exited-commitments-card"
   :entity/type :entity.type/card
   :common/owner "system"
   :card/entity-type :entity.type/fund
   :card/type :card.type/entity-list
   :card/title "Exited commitments"
   :card/description "This card contains commitments for the fund"
   :card/config {:tables [{:title nil
                           :collapsible? false
                           :entity-type :entity.type/fund-commitment
                           :filters {:operator   :AND
                                     :conditions [{:field    :fund-commitment/fund
                                                   :operator :=
                                                   :value    :primary-entity-id
                                                   :dynamic? true}
                                                  {:field    :fund-commitment/exit-date
                                                   :operator :not-blank}]}
                           :columns [{:field :fund-commitment/investor}
                                     {:field :fund-commitment/committed-date}
                                     {:field :fund-commitment/exit-date}]}]}})

(def person-view-1
  {:db/id "default-person-view"
   :entity/type :entity.type/view
   :common/owner "system"
   :view/name "Default view"
   :view/description "System default view for a person"
   :view/type :view.type/single-entity
   :view/entity-type :entity.type/person
   :view/cards #{"person-property-list-card-1"
                 "person-associations-card-1"
                 "person-activity-timeline-card-1"
                 "person-fees-card-1"
                 "person-tasks-card-1"

                 "investor-property-list-card-1"
                 "sale-agreement-property-list-card-1"}
   :view/access-level :view.access-level/private
   ;; TODO: add something like this to the real view schema?
   :view/system-default? true
   :view/configuration
   {:top-level-sections
    {:primary-entity
     {:sections
      {:person-view/summary {:cards ["person-property-list-card-1"
                                     "person-associations-card-1"
                                     "person-activity-timeline-card-1"]}
       :person-view/fees {:cards ["person-fees-card-1"]}
       :person-view/tasks {:cards ["person-tasks-card-1"]}}}

     :person-view/investor-profiles-where-legal-entity
     {:sections {:investor-view/summary {:ord 0
                                         :cards ["investor-property-list-card-1"]}}}

     :person-view/agreements-where-customer
     {:sections {:sale-agreement-view/summary {:ord 0
                                               :cards ["sale-agreement-property-list-card-1"]}}}}}})

(def person-property-list-card-1
  {:db/id "person-property-list-card-1"
   :entity/type :entity.type/card
   :card/type :card.type/property-list
   :card/entity-type :entity.type/person
   :card/title "Person info"
   :card/description "General information about the person"
   :card/config {:rows [{:cells [{:field :person/first-name
                                  :width 1}
                                 {:field :person/last-name
                                  :width 1}
                                 {:field :person/universal-email-address
                                  :width 2}]}
                        {:cells [{:field :person/notes
                                  :width 4}]}]}})

(def person-entity-associations-card-1
  {:db/id "person-associations-card-1"
   :entity/type :entity.type/card
   :card/type :card.type/associations
   :card/entity-type :entity.type/person
   :card/title "Associations"
   :card/description "Associated companies, deals and contacts"
   :card/config {:tables [person-associations-table-default-config
                          company-associations-table-default-config
                          deal-associations-table-default-config]}})

(def company-attachments-card-1
  {:db/id "company-attachments-card-1"
   :entity/type :entity.type/card
   :card/type :card.type/attachments
   :card/title "Attachments"
   :card/description "This is for attachments"
   :card/entity-type :entity.type/company
   :card/config {:attachments-card? true
                 :tables [{:id 1
                           :title "Attachments"
                           :entity-type :entity.type/attachment
                           :columns []}]}})

(def deal-property-list-card-1
  {:db/id "deal-property-list-card-1"
   :entity/type :entity.type/card
   :card/type :card.type/property-list
   :card/entity-type :entity.type/oppo
   :card/title "Deal information"
   :card/description "General information about the deal"
   :card/config {:rows [{:cells [{:field :oppo/owner
                                  :always-visible? true
                                  :width 1}
                                 {:field :oppo/stage
                                  :always-visible? true
                                  :width 1}
                                 {:field :oppo/status
                                  :always-visible? true
                                  :width 1}
                                 {:field :oppo/pipeline
                                  :always-visible? true
                                  :width 1}]}]}})

(def deal-associations-card-1
  {:db/id "deal-associations-card-1"
   :entity/type :entity.type/card
   :card/type :card.type/associations
   :card/entity-type :entity.type/oppo
   :card/title "Deal associations"
   :card/description "Associated contacts"
   :card/config {:tables [person-associations-table-default-config]}})

(def deal-tasks-card-1
  {:db/id "deal-tasks-card-1"
   :entity/type :entity.type/card
   :card/type :card.type/tasks
   :card/entity-type :entity.type/oppo
   :card/title "Deal tasks"
   :card/description "Tasks associated with the deal"
   :card/config tasks-card-default-config})

(def deal-attachments-card-1
  {:db/id "deal-attachments-card-1"
   :entity/type :entity.type/card
   :card/type :card.type/attachments
   :card/title "Deal documents"
   :card/description "Documents for the deal"
   ;; TODO: Maybe some cards like attachments are entity type agnostic?
   :card/entity-type :entity.type/oppo
   ;; TODO: Which type of config needed? Ask PO
   :card/config {}})

(def deal-risks-card-1
  {:db/id "deal-risks-card-1"
   :entity/type :entity.type/card
   :card/type :card.type/risks
   :card/title "Risks"
   :card/description "Risks for deal"
   :card/entity-type :entity.type/oppo
   :card/config {}})

(def person-activity-timeline-card-1
  {:db/id "person-activity-timeline-card-1"
   :entity/type :entity.type/card
   :card/type :card.type/activities
   :card/entity-type :entity.type/person
   :card/title "Activity timeline"
   :card/description "All activities for person and related entities"
   :card/config {}})

(def investor-property-list-card-1
  {:db/id "investor-property-list-card-1"
   :entity/type :entity.type/card
   :card/type :card.type/property-list
   :card/entity-type :entity.type/investor
   :card/title "Investor information"
   :card/description "General information about the investor"
   :card/config {:rows [{:cells [{:field :investor/name
                                  :always-visible? true
                                  :width 1}]}
                        {:cells [{:field :investor/description
                                  :always-visible? true
                                  :width 4}]}]}})

(def holding-property-list-card-1
  {:db/id "holding-property-list-card-1"
   :entity/type :entity.type/card
   :card/type :card.type/property-list
   :card/entity-type :entity.type/holding
   :card/title "Holding information"
   :card/description "General information about the holding"
   :card/config {:rows [{:cells [{:field :holding/name
                                  :always-visible? true
                                  :width 1}
                                 {:field :holding/owner
                                  :always-visible? true
                                  :width 1}
                                 {:field :holding/exit-status
                                  :always-visible? true
                                  :width 1}]}
                        {:cells [{:field :holding/exit-plan
                                  :always-visible? true
                                  :width 2}
                                 {:field :holding/recent-status
                                  :always-visible? true
                                  :width 2}]}
                        {:cells [{:field :holding/cur-valuation
                                  :width 1}
                                 {:field :holding/cur-paid-in-capital
                                  :width 1}
                                 {:field :holding/cur-distributions
                                  :width 1}]}]}})

(def sale-agreement-property-list-card-1
  {:db/id "sale-agreement-property-list-card-1"
   :entity/type :entity.type/card
   :card/type :card.type/property-list
   :card/entity-type :entity.type/sale-agreement
   :card/title "Agreement information"
   :card/description "General information about the agreement"
   :card/config {:rows [{:cells [{:field :sale-agreement/name
                                  :always-visible? true
                                  :width 1}
                                 {:field :sale-agreement/owner
                                  :always-visible? true
                                  :width 1}
                                 {:field :sale-agreement/credit
                                  :always-visible? true
                                  :width 1}
                                 {:field :sale-agreement/won-by
                                  :always-visible? true
                                  :width 1}]}]}})

(def fof-asset-property-list-card-1
  {:db/id "fof-asset-property-list-card-1"
   :entity/type :entity.type/card
   :card/type :card.type/property-list
   :card/entity-type :entity.type/fof-asset
   :card/title "Fund information"
   :card/description "General information about the fund"
   :card/config {:rows [{:cells [{:field :asset/name
                                  :width 1
                                  :always-visible? true}
                                 {:field :fof-asset/target-asset-class
                                  :width 1
                                  :always-visible? true}]}
                        {:cells [{:field :asset/description
                                  :always-visible? true
                                  :width 4}]}]}})

(def deal-decisions-card-1
  {:db/id "deal-decisions-card-1"
   :entity/type :entity.type/card
   :card/type :card.type/decisions
   :card/entity-type :entity.type/oppo
   :card/title "Decisions"
   :card/config {:table {:columns    [{:field :entity/type
                                       :label "Decision type"}
                                      {:field :decision/date}]
                         :sort-model [{:field :decision/date
                                       :direction :asc}]
                         :entity-type :entity.type/decision}}})

(def company-view-1
  {:db/id "default-company-view"
   :entity/type :entity.type/view
   :common/owner "system"
   :view/name "Default view"
   :view/description "This is the default view configuration for companies"
   :view/type :view.type/single-entity
   :view/entity-type :entity.type/company
   :view/cards #{"company-property-list-card-1"
                 "company-entity-associations-card-1"
                 "company-activities-card-1"
                 "company-attachments-card-1"
                 "company-fees-card-1"
                 "company-tasks-card-1"
                 "value-creations-card-1"

                 ;; linked main entity cards
                 "deal-decisions-card-1"
                 "deal-property-list-card-1"
                 "deal-associations-card-1"
                 "deal-attachments-card-1"
                 "deal-tasks-card-1"
                 "investor-property-list-card-1"
                 "holding-property-list-card-1"
                 "holding-risks-card-1"
                 "sale-agreement-property-list-card-1"
                 "fof-asset-property-list-card-1"}
   :view/access-level :view.access-level/private
   ;; TODO: add something like this to the real view schema?
   :view/system-default? true
   :view/configuration
   {:top-level-sections
    {:primary-entity
     {:sections {:company-view/summary  {:cards ["company-property-list-card-1"
                                                 "company-entity-associations-card-1"
                                                 "company-activities-card-1"
                                                 "company-attachments-card-1"]
                                         :ord 0
                                         :hidden? false}
                 :company-view/tasks {:cards ["company-tasks-card-1"]
                                      :ord 1
                                      :hidden? false}
                 :company-view/fees  {:cards ["company-fees-card-1"]
                                      :ord 2
                                      :hidden? false}
                 :company-view/risks {:cards []
                                      :ord 3
                                      :hidden? false}}}

     :company-view/deals-where-target-asset
     {:ord 0
      :sections {:oppo-view/summary {:ord 1
                                     :cards ["deal-property-list-card-1"
                                             "deal-associations-card-1"
                                             "deal-attachments-card-1"]

                                     :hidden? false}
                 :oppo-view/tasks   {:ord 2
                                     :cards ["deal-tasks-card-1"]
                                     :hidden? false}
                 :oppo-view/decisions {:ord 3
                                       :cards ["deal-decisions-card-1"]
                                       :hidden? false}
                 :oppo-view/risks {:ord 4
                                   :cards []
                                   :hidden? false}
                 :oppo-view/e-signatures {:ord 5
                                          :cards []
                                          :hidden? false}
                 :oppo-view/pre-investment-checks {:ord 6
                                                   :cards []
                                                   :hidden? false}}
      :hidden? false}

     :company-view/investor-profiles-where-legal-entity
     {:ord 1
      :sections {:investor-view/summary {:ord 0
                                         :cards ["investor-property-list-card-1"
                                                 "value-creations-card-1"]
                                         :hidden? false}}
      :hidden? false}

     :company-view/holdings-where-target-asset
     {:ord 2
      :sections {:holding-view/summary {:ord 0
                                        :cards ["holding-property-list-card-1"]}
                 :holding-view/risks {:ord 1
                                      :cards ["holding-risks-card-1"]}}
      :hidden? false}

     :company-view/funds-where-gp
     {:ord 3
      :sections {:fof-asset-view/summary {:ord 0
                                          :cards ["fof-asset-property-list-card-1"]}}
      :hidden? false}

     :company-view/agreements-where-customer
     {:ord 4
      :sections {:sale-agreement-view/summary {:ord 0
                                               :cards ["sale-agreement-property-list-card-1"]}}
      :hidden? false}}}})

;; Just for testing
(def simple-company-view
  {:db/id "simple-company-view"
   :entity/type :entity.type/view
   :common/owner "system"
   :view/name "Simple view"
   :view/description "This is a simple view configuration for companies"
   :view/type :view.type/single-entity
   :view/entity-type :entity.type/company
   :view/cards #{"company-property-list-card-1"}
   :view/access-level :view.access-level/private
   :view/system-default? true
   :view/configuration
   {:top-level-sections
    {:primary-entity
     {:sections {:company-view/summary  {:cards ["company-property-list-card-1"]
                                         :ord 0
                                         :hidden? false}
                 :company-view/tasks {:cards []
                                      :ord 1
                                      :hidden? true}
                 :company-view/fees  {:cards []
                                      :ord 2
                                      :hidden? true}
                 :company-view/risks {:cards []
                                      :ord 3
                                      :hidden? true}}}

     :company-view/deals-where-target-asset
     {:ord 0
      :hidden? true
      :sections {:oppo-view/summary {:ord 1
                                     :cards []
                                     :hidden? false}
                 :oppo-view/tasks   {:ord 2
                                     :cards []
                                     :hidden? false}
                 :oppo-view/decisions {:ord 3
                                       :cards []
                                       :hidden? false}
                 :oppo-view/risks {:ord 4
                                   :cards []
                                   :hidden? false}
                 :oppo-view/e-signatures {:ord 5
                                          :cards []
                                          :hidden? false}
                 :oppo-view/pre-investment-checks {:ord 6
                                                   :cards []
                                                   :hidden? false}}}

     :company-view/investor-profiles-where-legal-entity
     {:ord 1
      :hidden? true
      :sections {:investor-view/summary {:ord 0
                                         :cards []
                                         :hidden? false}}}

     :company-view/holdings-where-target-asset
     {:ord 2
      :hidden? true
      :sections {:holding-view/summary {:ord 0
                                        :cards []}
                 :holding-view/risks {:ord 1
                                      :cards []}}}

     :company-view/funds-where-gp
     {:ord 3
      :hidden? true
      :sections {:fof-asset-view/summary {:ord 0
                                          :cards []}}}

     :company-view/agreements-where-customer
     {:ord 4
      :hidden? true
      :sections {:sale-agreement-view/summary {:ord 0
                                               :cards []}}}}}})

(def company-fees-card-1
  {:db/id "company-fees-card-1"
   :entity/type :entity.type/card
   :card/type :card.type/fees
   :card/entity-type :entity.type/company
   :card/title "Company fees"
   :card/description "Fees associated with the company"
   :card/config {:table {:columns    [{:field :fee/payer}
                                      {:field :fee/cur-amount}
                                      {:field :fee/status}
                                      {:field :fee/date-fee-date}
                                      {:field :fee/type}]
                         :sort-model [{:field :fee/cur-amount
                                       :direction :desc}]
                         :entity-type :entity.type/fee}
                 :entity-peek {:entity-type :entity.type/fee
                               :visible-fields-strategy :fields-that-have-value
                               :visible-fields [{:field :fee/payer}]}}})

(def person-fees-card-1
  {:db/id "person-fees-card-1"
   :entity/type :entity.type/card
   :card/type :card.type/fees
   :card/entity-type :entity.type/person
   :card/title "Fees"
   :card/description "Fees associated with the company"
   :card/config {:table {:columns    [{:field :fee/payer}
                                      {:field :fee/cur-amount}
                                      {:field :fee/status}
                                      {:field :fee/date-fee-date}
                                      {:field :fee/type}]
                         :sort-model [{:field :fee/cur-amount
                                       :direction :desc}]
                         :entity-type :entity.type/fee}
                 :entity-peek {:entity-type :entity.type/fee
                               :visible-fields-strategy :fields-that-have-value
                               :visible-fields [{:field :fee/payer}]}}})

(def holding-risks-card-1
  {:db/id "holding-risks-card-1"
   :entity/type :entity.type/card
   :card/type :card.type/risks
   :card/entity-type :entity.type/holding
   :card/title "Holding risks"
   :card/description "risks associated with the holding"
   :card/config
   {:table {:columns    [{:field :risk/title}
                         {:field :risk/status}]
            :sort-model [{:field :risk/status
                          :direction :desc}]
            :entity-type :entity.type/risk-holding}
    :entity-peek {:entity-type :entity.type/risk-holding
                  :visible-fields-strategy :fields-that-have-value
                  :visible-fields []}}})

(def person-tasks-card-1
  {:db/id "person-tasks-card-1"
   :entity/type :entity.type/card
   :card/type :card.type/tasks
   :card/entity-type :entity.type/person
   :card/title "Tasks"
   :card/description "Tasks associated with the person"
   :card/config tasks-card-default-config})

(def company-tasks-card-1
  {:db/id "company-tasks-card-1"
   :entity/type :entity.type/card
   :card/type :card.type/tasks
   :card/entity-type :entity.type/company
   :card/title "Company tasks"
   :card/description "Tasks associated with the company"
   :card/config tasks-card-default-config})

(def company-property-list-card-1
  {:db/id "company-property-list-card-1"
   :entity/type :entity.type/card
   :card/type :card.type/property-list
   :card/entity-type :entity.type/company
   :card/title "Company info"
   :card/description "General company details"
   :card/config {:rows [{:height :auto
                         :cells [{:field :asset/name
                                  :width 1}
                                 {:field :company/website
                                  :width 1}
                                 {:field :asset/country
                                  :width 2}]}
                        {:cells [{:field :common/created-on
                                  :width 1}
                                 {:field :common/created-by
                                  :width 1}]}
                        {:cells [{:field :company/tag-stage
                                  :width 1
                                  :always-visible? true}
                                 {:field :company/tag-category
                                  :width 2
                                  :always-visible? true}]}
                        {:cells [{:field :asset/description
                                  :width 4}]}]}})

(def company-entity-associations-card-1
  {:db/id "company-entity-associations-card-1"
   :entity/type :entity.type/card
   :card/type :card.type/associations
   :card/entity-type :entity.type/company
   :card/title "Associations"
   :card/description "Associated companies, deals and contacts"
   :card/config {:tables [person-associations-table-default-config
                          company-associations-table-default-config
                          deal-associations-table-default-config]}})

(def company-activity-timeline-card-1
  {:db/id "company-activities-card-1"
   :entity/type :entity.type/card
   :card/type :card.type/activities
   :card/entity-type :entity.type/company
   :card/title "Activity timeline"
   :card/description "All activities for company and related entities"
   :card/config {}})

(def investors-value-creation-card-1
  {:db/id "value-creations-card-1"
   :entity/type :entity.type/card
   :card/type :card.type/value-creations
   :card/entity-type :entity.type/investor
   :card/title "Value creation"
   :card/description "Value creations associated with investors"
   :card/config {:table {:columns    [{:field :value-creation/title}
                                      {:field :value-creation/status}]
                         :sort-model [{:field :value-creation/status
                                       :direction :desc}]
                         :entity-type :entity.type/value-creation}
                 :entity-peek {:entity-type :entity.type/value-creation
                               :visible-fields-strategy :fields-that-have-value
                               :visible-fields []}}})

;; Counterparty diligence

(def project-counterparty-diligence-progress-card-1
  {:db/id "project-counterparty-diligence-progress-card-1"
   :entity/type :entity.type/card
   :card/type :card.type/counterparty-diligence-progress
   :card/entity-type :entity.type/project-counterparty-diligence
   :card/title "Progress"
   :card/description "Counterparty diligence progress"
   :card/config {}})

(def project-counterparty-diligence-property-list-card-1
  {:db/id "project-counterparty-diligence-property-list-card-1"
   :entity/type :entity.type/card
   :card/type :card.type/property-list
   :card/title "Project diligence details"
   :card/entity-type :entity.type/project-counterparty-diligence
   :card/config {:rows [{:cells [{:field :project-counterparty-diligence/project-name
                                  :width 1
                                  :always-visible? true}
                                 {:field :project-counterparty-diligence/fund-name
                                  :width 1
                                  :always-visible? true}
                                 {:field :project-counterparty-diligence/template
                                  :width 1
                                  :always-visible? true}
                                 {:field :counterparty-diligence/e-signature-required
                                  :width 1
                                  :always-visible? true}]}
                        {:cells [{:field :project-counterparty-diligence/project-description
                                  :always-visible? true
                                  :width 4}]}
                        {:cells [{:field :counterparty-diligence/note
                                  :always-visible? true
                                  :width 4}]}]}})

(def project-counterparty-diligence-docs-card-1
  {:db/id "project-counterparty-diligence-docs-card-1"
   :entity/type :entity.type/card
   :card/type :card.type/counterparty-diligence-docs
   :card/entity-type :entity.type/project-counterparty-diligence
   :card/title "Submission & Documents"
   :card/description "Counterparty diligence submission"
   :card/config {}})

(def project-counterparty-diligence-screening-card-1
  {:db/id "project-counterparty-diligence-screening-card-1"
   :entity/type :entity.type/card
   :card/type :card.type/counterparty-diligence-screening
   :card/entity-type :entity.type/project-counterparty-diligence
   :card/title "Screening"
   :card/description "Counterparty diligence screening"
   :card/config {}})

(def project-counterparty-diligence-answers-card-1
  {:db/id "project-counterparty-diligence-answers-card-1"
   :entity/type :entity.type/card
   :card/type :card.type/counterparty-diligence-answers
   :card/entity-type :entity.type/project-counterparty-diligence
   :card/title "Answers"
   :card/description "Counterparty diligence answers"
   :card/config {}})

(def project-counterparty-diligence-activities-card-1
  {:db/id "project-counterparty-diligence-activities-card-1"
   :entity/type :entity.type/card
   :card/type :card.type/activities
   :card/entity-type :entity.type/project-counterparty-diligence
   :card/title "Activity timeline"
   :card/description "Activities"
   :card/config {}})

(def project-counterparty-diligence-attachments-card-1
  {:db/id "project-counterparty-diligence-attachments-card-1"
   :entity/type :entity.type/card
   :card/type :card.type/attachments
   :card/entity-type :entity.type/project-counterparty-diligence
   :card/title "Attachments"
   :card/description "Attachments uploaded for this diligence"
   :card/config {:attachments-card? true
                 :tables [{:id 1
                           :title "Attachments"
                           :entity-type :entity.type/attachment
                           :columns []}]}})

(def project-counterparty-diligence-view-1
  {:db/id "project-counterparty-diligence-view-1"
   :entity/type :entity.type/view
   :common/owner "system"
   :view/name "Default view"
   :view/description "This is the default view configuration for project counterparty diligence"
   :view/type :view.type/single-entity
   :view/entity-type :entity.type/project-counterparty-diligence
   :view/access-level :view.access-level/private
   :view/cards #{"project-counterparty-diligence-progress-card-1"
                 "project-counterparty-diligence-property-list-card-1"
                 "project-counterparty-diligence-docs-card-1"
                 "project-counterparty-diligence-screening-card-1"
                 "project-counterparty-diligence-answers-card-1"
                 "project-counterparty-diligence-attachments-card-1"
                 "project-counterparty-diligence-activities-card-1"}
   :view/configuration
   {:top-level-sections
    {:primary-entity
     {:sections {:project-counterparty-diligence-view/summary
                 {:cards ["project-counterparty-diligence-progress-card-1"
                          "project-counterparty-diligence-property-list-card-1"
                          "project-counterparty-diligence-docs-card-1"
                          "project-counterparty-diligence-screening-card-1"
                          "project-counterparty-diligence-attachments-card-1"
                          "project-counterparty-diligence-activities-card-1"]
                  :ord 0
                  :hidden? false}
                 :project-counterparty-diligence-view/answers
                 {:cards ["project-counterparty-diligence-answers-card-1"]
                  :ord 1
                  :hidden? false}}}}}})

(def company-counterparty-diligence-property-list-card-1
  {:db/id "company-counterparty-diligence-property-list-card-1"
   :entity/type :entity.type/card
   :card/type :card.type/property-list
   :card/title "Company diligence details"
   :card/entity-type :entity.type/company-counterparty-diligence
   :card/config {:rows [{:cells [{:field :company-counterparty-diligence/company-name
                                  :width 1
                                  :always-visible? true}
                                 {:field :company-counterparty-diligence/template
                                  :always-visible? true
                                  :width 1}
                                 {:field :counterparty-diligence/e-signature-required
                                  :always-visible? true
                                  :width 1}]}
                        {:cells [{:field :counterparty-diligence/note
                                  :always-visible? true
                                  :width 4}]}]}})

(def company-counterparty-diligence-progress-card-1
  {:db/id "company-counterparty-diligence-progress-card-1"
   :entity/type :entity.type/card
   :card/type :card.type/counterparty-diligence-progress
   :card/entity-type :entity.type/company-counterparty-diligence
   :card/title "Progress"
   :card/description "Counterparty diligence progress"
   :card/config {}})

(def company-counterparty-diligence-docs-card-1
  {:db/id "company-counterparty-diligence-docs-card-1"
   :entity/type :entity.type/card
   :card/type :card.type/counterparty-diligence-docs
   :card/entity-type :entity.type/company-counterparty-diligence
   :card/title "Submission & Documents"
   :card/description "Counterparty diligence submission"
   :card/config {}})

(def company-counterparty-diligence-screening-card-1
  {:db/id "company-counterparty-diligence-screening-card-1"
   :entity/type :entity.type/card
   :card/type :card.type/counterparty-diligence-screening
   :card/entity-type :entity.type/company-counterparty-diligence
   :card/title "Screening"
   :card/description "Counterparty diligence screening"
   :card/config {}})

(def company-counterparty-diligence-answers-card-1
  {:db/id "company-counterparty-diligence-answers-card-1"
   :entity/type :entity.type/card
   :card/type :card.type/counterparty-diligence-answers
   :card/entity-type :entity.type/company-counterparty-diligence
   :card/title "Answers"
   :card/description "Counterparty diligence answers"
   :card/config {}})

(def company-counterparty-diligence-activities-card-1
  {:db/id "company-counterparty-diligence-activities-card-1"
   :entity/type :entity.type/card
   :card/type :card.type/activities
   :card/entity-type :entity.type/company-counterparty-diligence
   :card/title "Activity timeline"
   :card/description "Activities"
   :card/config {}})

(def company-counterparty-diligence-attachments-card-1
  {:db/id "company-counterparty-diligence-attachments-card-1"
   :entity/type :entity.type/card
   :card/type :card.type/attachments
   :card/entity-type :entity.type/company-counterparty-diligence
   :card/title "Attachments"
   :card/description "Attachments uploaded for this diligence"
   :card/config {:attachments-card? true
                 :tables [{:id 1
                           :title "Attachments"
                           :entity-type :entity.type/attachment
                           :columns []}]}})

(def company-counterparty-diligence-view-1
  {:db/id "company-counterparty-diligence-view-1"
   :entity/type :entity.type/view
   :common/owner "system"
   :view/name "Default view"
   :view/description "This is the default view configuration for company counterparty diligence"
   :view/type :view.type/single-entity
   :view/entity-type :entity.type/company-counterparty-diligence
   :view/access-level :view.access-level/private
   :view/cards #{"company-counterparty-diligence-property-list-card-1"
                 "company-counterparty-diligence-progress-card-1"
                 "company-counterparty-diligence-docs-card-1"
                 "company-counterparty-diligence-screening-card-1"
                 "company-counterparty-diligence-answers-card-1"
                 "company-counterparty-diligence-attachments-card-1"
                 "company-counterparty-diligence-activities-card-1"}
   :view/configuration
   {:top-level-sections
    {:primary-entity
     {:sections {:company-counterparty-diligence-view/summary
                 {:cards ["company-counterparty-diligence-progress-card-1"
                          "company-counterparty-diligence-property-list-card-1"
                          "company-counterparty-diligence-docs-card-1"
                          "company-counterparty-diligence-screening-card-1"
                          "company-counterparty-diligence-attachments-card-1"
                          "company-counterparty-diligence-activities-card-1"]
                  :ord 0
                  :hidden? false}
                 :company-counterparty-diligence-view/answers
                 {:cards ["company-counterparty-diligence-answers-card-1"]
                  :ord 1
                  :hidden? false}}}}}})

(def person-counterparty-diligence-progress-card-1
  {:db/id "person-counterparty-diligence-progress-card-1"
   :entity/type :entity.type/card
   :card/type :card.type/counterparty-diligence-progress
   :card/entity-type :entity.type/person-counterparty-diligence
   :card/title "Progress"
   :card/description "Counterparty diligence progress"
   :card/config {}})

(def person-counterparty-diligence-property-list-card-1
  {:db/id "person-counterparty-diligence-property-list-card-1"
   :entity/type :entity.type/card
   :card/type :card.type/property-list
   :card/title "Person diligence details"
   :card/entity-type :entity.type/person-counterparty-diligence
   :card/config {:rows [{:cells [{:field :person-counterparty-diligence/person-name
                                  :width 1
                                  :always-visible? true}
                                 {:field :person-counterparty-diligence/template
                                  :always-visible? true
                                  :width 1}
                                 {:field :counterparty-diligence/e-signature-required
                                  :width 1
                                  :always-visible? true}]}
                        {:cells [{:field :counterparty-diligence/note
                                  :always-visible? true
                                  :width 4}]}]}})

(def person-counterparty-diligence-docs-card-1
  {:db/id "person-counterparty-diligence-docs-card-1"
   :entity/type :entity.type/card
   :card/type :card.type/counterparty-diligence-docs
   :card/entity-type :entity.type/person-counterparty-diligence
   :card/title "Submission & Documents"
   :card/description "Counterparty diligence submission"
   :card/config {}})

(def person-counterparty-diligence-screening-card-1
  {:db/id "person-counterparty-diligence-screening-card-1"
   :entity/type :entity.type/card
   :card/type :card.type/counterparty-diligence-screening
   :card/entity-type :entity.type/person-counterparty-diligence
   :card/title "Screening"
   :card/description "Counterparty diligence screening"
   :card/config {}})

(def person-counterparty-diligence-answers-card-1
  {:db/id "person-counterparty-diligence-answers-card-1"
   :entity/type :entity.type/card
   :card/type :card.type/counterparty-diligence-answers
   :card/entity-type :entity.type/person-counterparty-diligence
   :card/title "Answers"
   :card/description "Counterparty diligence answers"
   :card/config {}})

(def person-counterparty-diligence-activities-card-1
  {:db/id "person-counterparty-diligence-activities-card-1"
   :entity/type :entity.type/card
   :card/type :card.type/activities
   :card/entity-type :entity.type/person-counterparty-diligence
   :card/title "Activity timeline"
   :card/description "Activities"
   :card/config {}})

(def person-counterparty-diligence-attachments-card-1
  {:db/id "person-counterparty-diligence-attachments-card-1"
   :entity/type :entity.type/card
   :card/type :card.type/attachments
   :card/entity-type :entity.type/person-counterparty-diligence
   :card/title "Attachments"
   :card/description "Attachments uploaded for this diligence"
   :card/config {:attachments-card? true
                 :tables [{:id 1
                           :title "Attachments"
                           :entity-type :entity.type/attachment
                           :columns []}]}})

(def person-counterparty-diligence-view-1
  {:db/id "person-counterparty-diligence-view-1"
   :entity/type :entity.type/view
   :common/owner "system"
   :view/name "Default view"
   :view/description "This is the default view configuration for person counterparty diligence"
   :view/type :view.type/single-entity
   :view/entity-type :entity.type/person-counterparty-diligence
   :view/access-level :view.access-level/private
   :view/cards #{"person-counterparty-diligence-progress-card-1"
                 "person-counterparty-diligence-property-list-card-1"
                 "person-counterparty-diligence-docs-card-1"
                 "person-counterparty-diligence-screening-card-1"
                 "person-counterparty-diligence-answers-card-1"
                 "person-counterparty-diligence-attachments-card-1"
                 "person-counterparty-diligence-activities-card-1"}
   :view/configuration
   {:top-level-sections
    {:primary-entity
     {:sections {:person-counterparty-diligence-view/summary
                 {:cards ["person-counterparty-diligence-progress-card-1"
                          "person-counterparty-diligence-property-list-card-1"
                          "person-counterparty-diligence-docs-card-1"
                          "person-counterparty-diligence-screening-card-1"
                          "person-counterparty-diligence-attachments-card-1"
                          "person-counterparty-diligence-activities-card-1"]
                  :ord 0
                  :hidden? false}
                 :person-counterparty-diligence-view/answers
                 {:cards ["person-counterparty-diligence-answers-card-1"]
                  :ord 0
                  :hidden? false}}}}}})

(def default-survey-profile-property-list-card
  {:db/id "default-survey-profile-property-list-card"
   :entity/type :entity.type/card
   :card/type :card.type/property-list
   :card/entity-type :entity.type/survey-profile
   :card/title "Survey profile info"
   :card/description "Survey profile details"
   :card/config {:rows [{:height :auto
                         :cells [{:field :survey-profile/our-contact
                                  :width 2}
                                 {:field :survey-profile/their-contact
                                  :width 2}]}
                        {:height :auto
                         :cells [{:field :survey-profile/notes
                                  :width 4
                                  :always-visible? true}]}]}})

(def default-survey-processes-card
  {:db/id "default-survey-processes-card"
   :entity/type :entity.type/card
   :card/type :card.type/survey-processes
   :card/entity-type :entity.type/survey-profile
   :card/title "Processes"
   :card/description "Survey processes"
   :card/config {:table {:columns    [{:field :survey-process/status}
                                      {:field :survey-process/template}
                                      {:field :survey-process/language}
                                      {:field :common/created-on}
                                      {:field :common/updated-on}]
                         :sort-model [{:field :common/created-on
                                       :direction :desc}]
                         :entity-type :entity.type/survey-process}}})

(def default-survey-profile-view
  {:db/id "default-survey-profile-view"
   :entity/type :entity.type/view
   :common/owner "system"
   :view/name "Default view"
   :view/description "This is the default view configuration for survey profiles"
   :view/type :view.type/single-entity
   :view/entity-type :entity.type/survey-profile
   :view/cards #{"default-survey-profile-property-list-card"
                 "default-survey-processes-card"}
   :view/access-level :view.access-level/private
   :view/system-default? true
   :view/configuration
   {:top-level-sections
    {:primary-entity
     {:sections {:survey-profile-view/summary {:cards ["default-survey-profile-property-list-card"
                                                       "default-survey-processes-card"]
                                               :ord 0
                                               :hidden? false}}}}}})

;; Hard-coded view & cards
(def entities
  [company-view-1
   simple-company-view

   default-survey-profile-view
   default-survey-profile-property-list-card
   default-survey-processes-card

   company-property-list-card-1
   company-activity-timeline-card-1
   company-entity-associations-card-1
   company-fees-card-1
   company-tasks-card-1
   company-attachments-card-1
   holding-risks-card-1
   investors-value-creation-card-1
   person-view-1
   fund-view-1
   fund-active-commitments-card
   fund-exited-commitments-card
   fund-property-list-card-1
   person-property-list-card-1
   person-entity-associations-card-1
   person-activity-timeline-card-1

   investor-property-list-card-1
   deal-decisions-card-1

   holding-property-list-card-1

   sale-agreement-property-list-card-1

   fof-asset-property-list-card-1

   deal-associations-card-1
   deal-tasks-card-1
   person-fees-card-1
   person-tasks-card-1
   deal-property-list-card-1
   deal-risks-card-1
   deal-attachments-card-1

   project-counterparty-diligence-progress-card-1
   project-counterparty-diligence-property-list-card-1
   project-counterparty-diligence-docs-card-1
   project-counterparty-diligence-screening-card-1
   project-counterparty-diligence-answers-card-1
   project-counterparty-diligence-view-1
   project-counterparty-diligence-activities-card-1
   project-counterparty-diligence-attachments-card-1

   company-counterparty-diligence-view-1
   company-counterparty-diligence-property-list-card-1
   company-counterparty-diligence-progress-card-1
   company-counterparty-diligence-docs-card-1
   company-counterparty-diligence-screening-card-1
   company-counterparty-diligence-answers-card-1
   company-counterparty-diligence-activities-card-1
   company-counterparty-diligence-attachments-card-1

   person-counterparty-diligence-view-1
   person-counterparty-diligence-property-list-card-1
   person-counterparty-diligence-docs-card-1
   person-counterparty-diligence-progress-card-1
   person-counterparty-diligence-screening-card-1
   person-counterparty-diligence-answers-card-1
   person-counterparty-diligence-activities-card-1
   person-counterparty-diligence-attachments-card-1])

(def entities-by-id
  (p/index-by :db/id entities))

(rf/reg-event-fx
 ::init
 (fn [{:keys [db]} _]
   (let [new-db (session-model/merge-entities db entities-by-id)]
     {:db new-db})))

(rf/reg-event-fx
 ::cleanup
 (fn [{:keys [db]}]
   (let [fake-entity-ids (keys entities-by-id)
         new-db (session-model/remove-entities db fake-entity-ids)]
     {:db new-db})))
